import { render } from "./Qna.vue?vue&type=template&id=03aa702c&scoped=true"
import script from "./Qna.vue?vue&type=script&lang=js"
export * from "./Qna.vue?vue&type=script&lang=js"

import "./Qna.vue?vue&type=style&index=0&id=03aa702c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03aa702c"]])

export default __exports__